import React from "react";
import { Box, Link, Text } from "@opendoor/bricks-next";
//#region src/AccountForm/AccountFormCinderblocks/AccountFormSubHeader.tsx
var AccountFormSubHeader = ({ loginSubHeaderText, registrationSubHeaderText, email, onValidEmailReset, hasSubmittedEmail, isNewHuman, hidePasswordField, phoneNumberInputHidden }) => {
	const actionText = isNewHuman ? "Signing up" : "Signing in";
	const subHeaderText = isNewHuman ? registrationSubHeaderText : loginSubHeaderText;
	return /* @__PURE__ */ React.createElement(Box, null, subHeaderText && /* @__PURE__ */ React.createElement(Text, {
		typography: "$subheaderSmall",
		marginTop: "$5x",
		marginBottom: "$5x",
		tag: "h2"
	}, subHeaderText), hasSubmittedEmail && !hidePasswordField && !phoneNumberInputHidden && /* @__PURE__ */ React.createElement(Text, {
		typography: "$bodySmall",
		tag: "p",
		gap: "$2x"
	}, actionText, " as", " ", /* @__PURE__ */ React.createElement(Link, {
		href: "#",
		size: "small",
		variant: "secondary",
		analyticsName: "Reset email",
		onPress: onValidEmailReset
	}, email)));
};
//#endregion
export { AccountFormSubHeader as default };

